var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('package-select',{attrs:{"value":_vm.ServicePackageId,"text":_vm.ServicePackageTxt,"mutation-name":_vm.mutationsMappers.mutationName,"filter":_vm.vozidloFilter,"label-key":"ServicePackage"},on:{"clear":_vm.clear}})}
var staticRenderFns = []

export { render, staticRenderFns }